<template>
  <div class="view-container">
    <div class="view-gabarit">
      <form v-if="!isFetching && study" @submit.prevent="submitForm">
        <div v-if="study.force_car_only" class="view-row">
          <i class="icon-car row-icon-description"></i>
          <div class="view-description">
            <p class="baseline">{{ $t('studyCreation.forceCarOnly') }}</p>
            <p class="description">{{ $t('studyCreation.forceCarOnlyDetail') }}</p>
          </div>
        </div>
        <div v-else class="view-row clean-row">
          <i class="icon-bus row-icon-description"></i>
          <div class="view-description">
            <p class="baseline">{{ $t('studyCreation.chooseCalculBase') }}</p>
          </div>
        </div>
        <div v-if="!study.force_car_only" class="view-row sub-row" :class="{ disabled: individualTransportOnly || publicTransportProvider !== 2 }">
          <svg class="subdescription-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <g id="public_transport" fill="currentColor">
              <path
                d="M37.75,36.33l.08-.08A5.73,5.73,0,0,0,39.75,32V12c0-6.45-6-7.75-15.75-7.75S8.25,5.55,8.25,12V32a5.73,5.73,0,0,0,1.92,4.25l.08.08V40A1.76,1.76,0,0,0,12,41.75h2A1.76,1.76,0,0,0,15.75,40V37.75h16.5V40A1.76,1.76,0,0,0,34,41.75h2A1.76,1.76,0,0,0,37.75,40ZM12.51,9.8C13.94,8.42,17.7,7.75,24,7.75s10.06.67,11.49,2.05l.45.43H12.06ZM36.25,32a2.24,2.24,0,0,1-.76,1.65l-.65.6H13.16l-.65-.61A2.18,2.18,0,0,1,11.75,32V23.75h24.5Zm0-11.75H11.75V13.73h24.5Z"
              />
              <circle cx="17" cy="29" r="2.75" />
              <circle cx="31" cy="29" r="2.75" />
            </g>
          </svg>

          <div class="view-description">
            <p class="description">{{ $t('studyCreation.wouldFutureTransportLine') }}</p>
            <p class="description-small">({{ $t('studyCreation.wouldFutureTransportLineOnlyFrance') }})</p>
          </div>
          <div class="view-content">
            <fieldset>
              <input id="futurVision" v-model="futurVision" type="checkbox" :disabled="individualTransportOnly" />
              <label for="futurVision" class="switch">x</label>
            </fieldset>
          </div>
        </div>
        <div v-if="futurVision" class="view-row sub-row">
          <i class="icon-cross row-icon-description placeholder"></i>
          <div class="view-description">
            <fieldset class="bubble">
              <span>{{ $t('studyCreation.maturityDate') }}</span>
              <div class="sub-bubble">
                <input id="futurVision2027" v-model="futurVisionYear" type="radio" value="3" />
                <label for="futurVision2027">{{ $t('studyCreation.horizon2027') }}</label>
                <input id="futurVision2031" v-model="futurVisionYear" type="radio" value="4" />
                <label for="futurVision2031">{{ $t('studyCreation.horizon2031') }}</label>
              </div>
            </fieldset>
          </div>
          <div class="view-content"></div>
        </div>
        <div v-if="!study.force_car_only" class="view-row sub-row" :class="{ disabled: futurVision || personalizedTransportOnly }">
          <svg class="subdescription-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <g id="car" fill="currentColor">
              <path
                d="M41.75,24,37.6,12.1A2.73,2.73,0,0,0,35,10.25H13a2.74,2.74,0,0,0-2.6,1.85L6.25,24V40A1.76,1.76,0,0,0,8,41.75h2A1.76,1.76,0,0,0,11.75,40V37.75h24.5V40A1.76,1.76,0,0,0,38,41.75h2A1.76,1.76,0,0,0,41.75,40ZM13.52,13.75H34.46l2.33,6.72H11.19Zm24.31,20.5H10.17V23.75H37.83Z"
              />
              <circle cx="15" cy="29" r="2.75" />
              <circle cx="33" cy="29" r="2.75" />
            </g>
          </svg>

          <div class="view-description">
            <p class="description">{{ $t('studyCreation.carOnly') }}</p>
          </div>
          <div class="view-content">
            <fieldset>
              <input id="individualTransportOnly" v-model="individualTransportOnly" type="checkbox" :disabled="futurVision || personalizedTransportOnly" />
              <label for="individualTransportOnly" class="switch">x</label>
            </fieldset>
          </div>
        </div>

        <div class="view-row sub-row" :class="{ disabled: individualTransportOnly }">
          <svg class="subdescription-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <g id="public_transport" fill="currentColor">
              <path
                d="M37.75,36.33l.08-.08A5.73,5.73,0,0,0,39.75,32V12c0-6.45-6-7.75-15.75-7.75S8.25,5.55,8.25,12V32a5.73,5.73,0,0,0,1.92,4.25l.08.08V40A1.76,1.76,0,0,0,12,41.75h2A1.76,1.76,0,0,0,15.75,40V37.75h16.5V40A1.76,1.76,0,0,0,34,41.75h2A1.76,1.76,0,0,0,37.75,40ZM12.51,9.8C13.94,8.42,17.7,7.75,24,7.75s10.06.67,11.49,2.05l.45.43H12.06ZM36.25,32a2.24,2.24,0,0,1-.76,1.65l-.65.6H13.16l-.65-.61A2.18,2.18,0,0,1,11.75,32V23.75h24.5Zm0-11.75H11.75V13.73h24.5Z"
              />
              <circle cx="17" cy="29" r="2.75" />
              <circle cx="31" cy="29" r="2.75" />
            </g>
          </svg>

          <div class="view-description">
            <p class="description">{{ $t('studyCreation.personalizedTransportOnly') }}</p>
          </div>
          <div class="view-content">
            <fieldset>
              <input id="personalizedTransportOnly" v-model="personalizedTransportOnly" type="checkbox" :disabled="individualTransportOnly" />
              <label for="personalizedTransportOnly" class="switch">x</label>
            </fieldset>
          </div>
        </div>

        <div v-if="!study.carWithTollOnly" class="view-row sub-row">
          <svg class="subdescription-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <g id="car_no_toll" fill="currentColor">
              <circle cx="10" cy="29" r="2.75" />
              <circle cx="28" cy="29" r="2.75" />
              <path
                d="M28.42,20.47H6.19l2.33-6.72H24.41A13.4,13.4,0,0,1,24,10.5c0-.08,0-.17,0-.25H8A2.74,2.74,0,0,0,5.4,12.1L1.25,24V40A1.76,1.76,0,0,0,3,41.75H5A1.76,1.76,0,0,0,6.75,40V37.75h24.5V40A1.76,1.76,0,0,0,33,41.75h2A1.76,1.76,0,0,0,36.75,40V24l0-.08A13.43,13.43,0,0,1,28.42,20.47ZM33,34.25H5V23.75H33Z"
              />
              <path
                d="M47.88,4.88,45.76,2.76,43.65,4.87a6.37,6.37,0,0,0-6.33-.19,6.35,6.35,0,0,0-3-.75,6.43,6.43,0,0,0-2.2,12.47l-1,1,2.12,2.12,3-3a6.6,6.6,0,0,0,1-.43,6.35,6.35,0,0,0,3,.75A6.43,6.43,0,0,0,45.79,7ZM40.32,6.41a3.89,3.89,0,0,1,1.49.3l-5.14,5.14a3.89,3.89,0,0,1-.3-1.49A4,4,0,0,1,40.32,6.41Zm-9.95,3.95a4,4,0,0,1,3.95-3.95,3.56,3.56,0,0,1,.86.11,6.32,6.32,0,0,0-.34,7.16l-.62.62A3.94,3.94,0,0,1,30.37,10.36Zm13.9,0a4,4,0,0,1-4,4A3.84,3.84,0,0,1,38.77,14L44,8.81A3.84,3.84,0,0,1,44.27,10.36Z"
              />
            </g>
          </svg>

          <div class="view-description">
            <p class="description">{{ $t('studyCreation.carWithTollOnly') }}</p>
          </div>
          <div class="view-content">
            <fieldset>
              <input id="carWithTollOnly" v-model="carWithTollOnly" type="checkbox" />
              <label for="carWithTollOnly" class="switch">x</label>
            </fieldset>
          </div>
        </div>
        <div v-if="false" class="view-row sub-row">
          <svg class="subdescription-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <g id="no_bike" fill="currentColor">
              <path d="M30.57,11.66A3.67,3.67,0,1,0,26.9,8,3.68,3.68,0,0,0,30.57,11.66Z" />
              <path d="M37,23.57a9.17,9.17,0,1,0,9.17,9.17A9.08,9.08,0,0,0,37,23.57Zm0,15.59a6.42,6.42,0,1,1,6.42-6.42A6.5,6.5,0,0,1,37,39.16Z" />
              <path
                d="M29.75,19.5a12.8,12.8,0,0,0,7.42,2.24V18.07a9.06,9.06,0,0,1-4.72-1.28L45,4.21,42.91,2.09,30.12,14.88l-3-3a4.49,4.49,0,0,0-2.93-1.1,3.11,3.11,0,0,0-2.57,1.1L16.45,17a3.65,3.65,0,0,0-1.1,2.57,3.09,3.09,0,0,0,1.1,2.57l3.44,3-1.61,1.62a9.12,9.12,0,0,0-7-3.16,9.19,9.19,0,0,0-6,16.13L.79,44.22l2.12,2.12L8,41.28a9.33,9.33,0,0,0,3.36.63,9.08,9.08,0,0,0,9.16-9.17,9.33,9.33,0,0,0-.62-3.36l2.29-2.29.17.15v9.17H26V25l-.86-.91ZM4.9,32.74a6.5,6.5,0,0,1,6.42-6.42,6.44,6.44,0,0,1,5,2.4l-9,9A6.44,6.44,0,0,1,4.9,32.74Zm12.83,0a6.5,6.5,0,0,1-6.41,6.42,6.86,6.86,0,0,1-1.12-.11l7.43-7.43A6.86,6.86,0,0,1,17.73,32.74ZM22,20.82l4.4-4.4,1.12,1.12L23,22Z"
              />
            </g>
          </svg>

          <div class="view-description">
            <p class="description">{{ $t('studyCreation.noBike') }}</p>
          </div>
          <div class="view-content">
            <fieldset>
              <input id="noBike" v-model="noBike" type="checkbox" />
              <label for="noBike" class="switch">x</label>
            </fieldset>
          </div>
        </div>
        <div class="view-row">
          <i class="icon-calendar row-icon-description"></i>
          <div class="view-description">
            <p class="baseline">{{ $t('studyCreation.studyDate') }}</p>
            <p class="description">{{ $t('studyCreation.optimisationInfo') }}</p>
          </div>
          <div class="view-content">
            <fieldset>
              <VueDatePicker
                v-model="trackingDate"
                :min-date="minDate"
                :max-date="maxDate"
                :time-config="{ enableTimePicker: false }"
                :input-attrs="{ clearable: false, hideInputIcon: true }"
              />
            </fieldset>
          </div>
        </div>
        <div class="view-row">
          <i class="icon-clock row-icon-description"></i>
          <div class="view-description">
            <p class="baseline">{{ $t('studyCreation.chooseTime') }}</p>
            <p class="description">
              {{ $t('studyCreation.chooseTimeDetail') }}<br />{{ $t('studyCreation.chooseTimeDetailOutward') }}<br />{{
                $t('studyCreation.chooseTimeDetailReturn')
              }}
            </p>
          </div>
          <div class="view-content">
            <div class="tracking-date">{{ travelTimeType === 1 ? $t('arrivalAt') : $t('departureAt') }} :</div>
            <fieldset class="select-box">
              <select v-model="trackingTime">
                <option
                  v-for="(time, i) in currentTimes"
                  :key="time"
                  :value="time"
                  :disabled="
                    new Date(trackingDate).getDate() === new Date().getDate() && i <= new Date().getHours() * 2 + (new Date().getMinutes() > 30 ? 2 : 1)
                  "
                >
                  {{ time }}
                </option>
              </select>
            </fieldset>
          </div>
        </div>
        <div class="view-row">
          <i class="icon-clock row-icon-description"></i>
          <div class="view-description">
            <p class="baseline">{{ $t('studyCreation.sensitiveCaseDuration') }}</p>
            <p class="description">{{ $t('studyCreation.sensitiveCaseDurationDetail') }}</p>
          </div>
          <div class="view-content">
            <fieldset class="select-box">
              <div class="minute-input">
                <input v-model="sensitiveCaseDuration" type="number" />
                <span class="unit">min</span>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="view-row">
          <i class="icon-radar row-icon-description"></i>
          <div class="view-description">
            <p class="baseline">{{ $t('studyCreation.radarPoiRadius') }}</p>
            <p class="description">{{ $t('studyCreation.radarPoiRadiusDetail') }}</p>
          </div>
          <div class="view-content">
            <fieldset class="select-box">
              <select v-model="poiRadius">
                <option :value="500">{{ $t('studyCreation.radarPoiRadius500') }}</option>
                <option :value="1000">{{ $t('studyCreation.radarPoiRadius1000') }}</option>
                <option :value="1500">{{ $t('studyCreation.radarPoiRadius1500') }}</option>
              </select>
            </fieldset>
          </div>
        </div>
        <div class="view-row disabled">
          <i class="icon-radar row-icon-description"></i>
          <div class="view-description">
            <p class="baseline">{{ $t('studyCreation.heatmap') }}</p>
            <p class="description">{{ $t('studyCreation.heatmapDetail') }}</p>
          </div>
          <div class="view-content">
            <fieldset class="select-box">
              <input id="heatmap" v-model="heatmap" type="checkbox" />
              <label for="heatmap" class="switch">x</label>
            </fieldset>
          </div>
        </div>
        <fieldset>
          <button :class="['study-button', 'main']" type="submit">{{ $t('validate') }}</button>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const nextDate = new Date();
    nextDate.setDate(nextDate.getDate() + ((2 + 7 - nextDate.getDay()) % 7));

    if (nextDate.getDate() === new Date().getDate()) {
      nextDate.setDate(nextDate.getDate() + 7);
    }

    const minDate = new Date(nextDate.getTime());
    const maxDate = new Date(nextDate.getTime());
    minDate.setDate(nextDate.getDate() - 7);
    maxDate.setDate(nextDate.getDate() + 14);

    return {
      isFetching: true,
      futurVision: false,
      futurVisionYear: '3',
      trackingType: '2',
      poiRadius: 500,
      heatmap: false,
      individualTransportOnly: false,
      personalizedTransportOnly: false,
      carWithTollOnly: false,
      noBike: false,
      trackingDate: nextDate.toISOString(),
      minDate: new Date().toISOString(),
      maxDate: new Date().toISOString(),
      currentTimes: this.generateTimes(),
      trackingTime: '9 h 00',
      travelType: new Date().getHours() < 13 ? '2' : '1',
      travelTimeType: 1,
      privateTransportProvider: 0,
      publicTransportProvider: 0,
      sensitiveCaseDuration: 45,
      study: null,
    };
  },

  watch: {
    trackingDate(newVal) {
      const newDate = new Date(newVal);
      this.travelType = newDate.getHours() < 13 ? '2' : '1';

      const today = new Date();

      if (newDate.getDate() === today.getDate()) {
        this.trackingTime = this.currentTimes[today.getHours() * 2 + (today.getMinutes() > 30 ? 3 : 2)];
      }
    },
  },

  mounted() {
    const id = this.$route.params.studyId;
    this.$store.dispatch('getStudyProductionDate', { id }).then(response => {
      this.minDate = new Date(response.start_date * 1000).toISOString();
      this.maxDate = new Date(response.end_date * 1000).toISOString();

      if (new Date(this.trackingDate) > new Date(this.maxDate)) {
        this.trackingDate = this.maxDate;
      }

      if (new Date(this.trackingDate) < new Date(this.minDate)) {
        this.trackingDate = this.minDate;
      }
    });
    this.$store.dispatch('getStudy', { id }).then(response => {
      this.study = response;
      this.isFetching = false;

      this.futurVision = this.study.futur_transport_type !== 0;
      this.futurVisionYear = this.study.futur_transport_type;
      this.poiRadius = this.study.poi_radius || 500;
      this.individualTransportOnly = this.study.individual_transport_only;
      this.personalizedTransportOnly = this.study.personalized_transport_only;
      this.carWithTollOnly = !this.study.car_with_toll_only;
      this.privateTransportProvider = this.study.private_transport_provider;
      this.publicTransportProvider = this.study.public_transport_provider;
      this.travelType = this.study.travel_type;
      this.travelTimeType = this.study.travel_time_type;
      this.sensitiveCaseDuration = this.study.sensitive_case_duration;

      this.trackingTime = this.travelTimeType === 1 ? '9 h 00' : '8 h 00';
    });
  },

  methods: {
    generateTimes() {
      const times = [];
      for (let i = 0; i < 24; i++) {
        times.push(`${i} h 00`);
        times.push(`${i} h 30`);
      }
      return times;
    },

    toDateWithoutTimezone(date) {
      const timezoneOffset = date.getTimezoneOffset() * 60000; // in milliseconds
      return new Date(date.valueOf() - timezoneOffset).toISOString().slice(0, -1);
    },

    submitForm() {
      const { travelType, poiRadius, trackingDate } = this;

      const actualDate = new Date(trackingDate);
      const horaire = this.trackingTime.split(' h ');
      actualDate.setHours(horaire[0]);
      actualDate.setMinutes(horaire[1]);

      const payload = {};
      payload.individual_transport_only = this.individualTransportOnly || this.force_car_only;
      payload.personalized_transport_only = this.personalizedTransportOnly;
      payload.car_with_toll_only = !this.carWithTollOnly;
      payload.travel_type = parseInt(travelType);
      payload.futur_transport_type = !this.futurVision ? 0 : parseInt(this.futurVisionYear);
      payload.date = this.toDateWithoutTimezone(actualDate);
      payload.poi_radius = parseInt(poiRadius);
      payload.sensitive_case_duration = this.sensitiveCaseDuration;
      payload.process_heatmap = this.heatmap;

      this.$store
        .dispatch('patchStudy', {
          id: this.$route.params.studyId,
          payload,
        })
        .then(() => {
          this.$router.push({ name: 'studySummary' });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.view-container {
  padding-bottom: 96px;
}

.admin {
  fieldset {
    margin-left: 0;
  }

  .view-row {
    transition: 0.2s ease-out;

    &.disabled {
      opacity: 0.4;
      cursor: not-allowed;
      pointer-events: none;
    }

    &.clean-row {
      padding-bottom: 0;
    }

    &.sub-row {
      border-top: none;
      padding-top: 0;

      p {
        &:first-child {
          margin-top: 0;
        }
      }

      &.disabled {
        opacity: 0.4;

        label {
          cursor: not-allowed;
        }
      }
    }

    .view-description {
      flex: 2.5;
      padding-right: 60px;
      box-sizing: border-box;

      .description-small {
        font-size: 0.8em;
        margin-top: -12px;
      }

      fieldset {
        &.bubble {
          background-color: #f8f7f7;
          max-width: initial;
          min-height: 80px;
          line-height: 80px;
          margin-right: -100px;
          position: relative;
          margin-top: -1.75em;
          border-radius: 1px;

          &:before {
            content: '';
            display: block;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #f8f7f7;
            position: absolute;
            bottom: 100%;
            left: 28px;
            margin-bottom: -1px;
          }

          span {
            margin-left: 30px;
            display: inline-block;
          }

          .sub-bubble {
            display: inline-block;
            float: right;
          }

          label {
            margin-bottom: 0;
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            margin-right: 28px;
            line-height: 1.2;
            vertical-align: middle;
          }
        }
      }
    }

    .minute-input {
      position: relative;
      display: flex;
      align-items: center;
      width: 120px;

      input {
        text-align: right;
        border: 1px solid #e3e3e3;
        border-radius: 2px;
        color: inherit;
        font-family: inherit;
        font-size: 14px;
        box-sizing: border-box;
        width: 100%;
        padding-right: 40px;
        outline: none;
      }

      .unit {
        position: absolute;
        right: 8px;
        font-size: 14px;
      }
    }
  }

  .tracking-date {
    margin: 4px 0 12px;
  }
}

.row-icon-description {
  font-size: 2.75em;
  margin: 0 50px;
  color: #dbd6c7;

  &.placeholder {
    visibility: hidden;
  }
}

.subdescription-icon {
  font-size: 2em;
  width: 32px;
  margin: 0 24px 0 96px;
  color: colors.$red-color;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent;
  border: 1px solid #e3e3e3;
  border-radius: 2px;
  color: inherit;
  font-family: inherit;
  font-size: 14px;
  line-height: 38px;
  box-sizing: border-box;
  min-width: 120px;
  padding-left: 13px;
  outline: none;
}

.study-button {
  margin-left: 160px;
}
</style>
